import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const shortcuts = [
  { category: 'General', items: [
    { keys: ['⌘', 'K'], desc: 'Command Palette' },
    { keys: ['⌘', 'S'], desc: 'Save Note' },
    { keys: ['⌘', 'N'], desc: 'New Note' },
    { keys: ['?'], desc: 'Show Shortcuts' },
  ]},
  { category: 'Editor', items: [
    { keys: ['⌘', 'B'], desc: 'Bold' },
    { keys: ['⌘', 'I'], desc: 'Italic' },
    { keys: ['⌘', 'E'], desc: 'Inline Code' },
    { keys: ['⌘', 'K'], desc: 'Insert Link' },
    { keys: ['⌘', 'U'], desc: 'Strikethrough' },
    { keys: ['Tab'], desc: 'Indent' },
  ]},
  { category: 'Markdown Shortcuts', items: [
    { keys: ['#', 'Space'], desc: 'Heading 1' },
    { keys: ['##', 'Space'], desc: 'Heading 2' },
    { keys: ['###', 'Space'], desc: 'Heading 3' },
    { keys: ['-', 'Space'], desc: 'Bullet List' },
    { keys: ['1.', 'Space'], desc: 'Numbered List' },
    { keys: ['>', 'Space'], desc: 'Blockquote' },
    { keys: ['```'], desc: 'Code Block' },
    { keys: ['---'], desc: 'Divider' },
  ]},
  { category: 'Slash Commands', items: [
    { keys: ['/'], desc: 'Open Slash Menu' },
    { keys: ['Esc'], desc: 'Close Menu' },
  ]},
];

export default function KeyboardShortcuts({ open, onClose }) {
  useEffect(() => {
    const handler = (e) => { if (e.key === '?' && !e.target.closest('input, textarea')) { e.preventDefault(); onClose(); } };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center">
      <div className="absolute inset-0 bg-background/80 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-lg bg-popover border rounded-xl shadow-2xl p-6 animate-in fade-in zoom-in-95">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold">Keyboard Shortcuts</h2>
          <button onClick={onClose} className="text-muted-foreground hover:text-foreground"><X size={18} /></button>
        </div>
        <div className="space-y-4 max-h-[60vh] overflow-y-auto">
          {shortcuts.map(cat => (
            <div key={cat.category}>
              <h3 className="text-sm font-medium text-muted-foreground mb-2">{cat.category}</h3>
              <div className="space-y-1">
                {cat.items.map(item => (
                  <div key={item.desc} className="flex items-center justify-between py-1">
                    <span className="text-sm">{item.desc}</span>
                    <div className="flex gap-1">
                      {item.keys.map((k, i) => (
                        <React.Fragment key={i}>
                          <kbd className="px-1.5 py-0.5 text-xs bg-muted border rounded font-mono">{k}</kbd>
                          {i < item.keys.length - 1 && <span className="text-muted-foreground">+</span>}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
